<script setup lang="ts">
import { type Rivista } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";

defineProps<{
  content: Rivista;
  compact?: boolean;
  showAreas?: boolean;
}>();
</script>

<template>
  <FrontContentItemsBaseItem
    v-bind="$props"
    :title="content.title"
    :date="content.created_at"
    :abstract="content.abstract"
    :show-areas="showAreas"
    :compact="compact"
    :areas="content.areas"
    :link="link({ rivista: content })"
    info-label="Rivista"
  >
    <template #info></template>
  </FrontContentItemsBaseItem>
</template>
